import { router } from 'expo-router';
import { Pressable } from 'react-native';
import Animated, { FadeIn, LinearTransition } from 'react-native-reanimated';
import {
    BodyLargeEmphasized,
    BodySmallRegular,
    isWeb,
    View,
    XStack,
    YStack,
} from 'smoothie';

import { FruitfulCardIcon } from '../../../banking/components/cards/FruitfulCard';
import useUnactivatedPhysicalCard from '../../../banking/hooks/card/useUnactivatedPhysicalCard';
import { CardForm } from '../../../banking/types/Card';
import { SIDEBAR_CONTENT_MAX_WIDTH } from '../../../common/utils/homeUtils';

export const ActivateCardWidget = () => {
    const { card: unactivatedCard, isLoading } = useUnactivatedPhysicalCard();

    if (isLoading || unactivatedCard == null) {
        return null;
    }

    const handleActivateCard = () => {
        router.push({
            pathname: '/banking/card/activate-card',
            params: {
                syncteraAccountId: unactivatedCard.syncteraAccountId,
                cardId: unactivatedCard.id,
            },
        });
    };

    return (
        <Animated.View
            style={{ width: '100%' }}
            {...(isWeb
                ? { entering: FadeIn.duration(500) }
                : { layout: LinearTransition.duration(500) })}
        >
            <View
                width="100%"
                maxWidth={SIDEBAR_CONTENT_MAX_WIDTH}
                alignSelf="center"
                backgroundColor="$gray200"
                borderRadius={24}
                padding={16}
            >
                <XStack gap={16} alignItems="center">
                    <FruitfulCardIcon form={CardForm.PHYSICAL} />
                    <YStack gap={4} flex={1}>
                        <BodyLargeEmphasized>
                            Your card is on its way!
                        </BodyLargeEmphasized>
                        <XStack alignItems="center" flexWrap="wrap">
                            <BodySmallRegular color="$gray1000">
                                Arrives in 5-7 days {'• '}
                            </BodySmallRegular>
                            <Pressable onPress={handleActivateCard}>
                                <BodySmallRegular
                                    color="$gray1000"
                                    textDecorationLine="underline"
                                >
                                    Activate card
                                </BodySmallRegular>
                            </Pressable>
                        </XStack>
                    </YStack>
                </XStack>
            </View>
        </Animated.View>
    );
};
